import { useEffect } from "react";
// components
import ProfileDesktop from "src/components/UI/Profile/profile-desktop";
import ProfileMobile from "src/components/UI/Profile/profile-mobile";
// redux
import { useSelector } from "react-redux";

const Profile = ({}) => {
  const mobileMode = useSelector((state: any) => state.app.mobileMode);

  return <>{!mobileMode ? <ProfileDesktop /> : <ProfileMobile />}</>;
};
export default Profile;
